import { useGsCloudBackend } from '@gat-ship/http-client'
import type {
  AiExtractDataRequestPayload,
  AiExtractDataResponse,
  AiExtractDataRequestResponse,
  GetAssetRequestResponse,
  GetAssetRequestPayload,
  GetAssetsByTargetRequestResponse,
  GetAssetsByTargetRequestPayload,
  AddAssetRequestResponse,
  AddAssetRequestPayload,
  UpdateAssetRequestResponse,
  UpdateAssetRequestPayload,
  RemoveAssetRequestResponse,
  RemoveAssetRequestPayload,
  IntrospectTargetRequestPayload,
  IntrospectTargetResponse
} from '@gat-ship/types'
import { globalUtils } from '@gat-ship/utils'

export function useAiApiCalls() {
  const { apiGet, apiPost, apiPut, apiDelete } = useGsCloudBackend()

  async function extractDataRequest(payload: AiExtractDataRequestPayload) {
    const response = await apiPost<
      AiExtractDataRequestResponse<AiExtractDataResponse>
    >('/ai/extract', payload, globalUtils.functions.uuid())
    return response
  }

  async function getAssetRequest(payload: GetAssetRequestPayload) {
    const response = await apiGet<GetAssetRequestResponse>(
      `/ai/prompt-library/${payload.id}`
    )
    return response
  }

  async function getAssetsByTargetRequest(
    payload: GetAssetsByTargetRequestPayload
  ) {
    const response = await apiGet<GetAssetsByTargetRequestResponse>(
      `/ai/prompt-library/by-target/${payload.target}`
    )
    return response
  }

  async function addAssetRequest(payload: AddAssetRequestPayload) {
    const response = await apiPost<AddAssetRequestResponse>(
      '/ai/prompt-library',
      payload.body,
      globalUtils.functions.uuid()
    )
    return response
  }

  async function updateAssetRequest(payload: UpdateAssetRequestPayload) {
    const response = await apiPut<UpdateAssetRequestResponse>(
      `/ai/prompt-library/${payload.pathParams.id}`,
      payload.body,
      globalUtils.functions.uuid()
    )
    return response
  }

  async function removeAssetRequest(payload: RemoveAssetRequestPayload) {
    const response = await apiDelete<RemoveAssetRequestResponse>(
      `/ai/prompt-library/${payload.pathParams.id}`,
      undefined,
      globalUtils.functions.uuid()
    )
    return response
  }

  async function introspectTargetRequest(
    payload: IntrospectTargetRequestPayload
  ) {
    const response = await apiGet<IntrospectTargetResponse>(
      `/ai/introspection/${payload.pathParams.target}`,
      {
        params: payload.queryParams
      }
    )
    return response
  }

  return {
    extractDataRequest,
    getAssetRequest,
    getAssetsByTargetRequest,
    addAssetRequest,
    updateAssetRequest,
    removeAssetRequest,
    introspectTargetRequest
  }
}
